<template>
  <div class="policy-utility-actions" role="toolbar" aria-label="政策实训辅助功能">
    <button type="button" class="policy-utility-action" :class="{ active: indicatorActive }" :disabled="inactive" aria-label="指标监测" title="指标监测" :aria-pressed="indicatorActive" @click="$emit('indicators')">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 19V5M4 19h16M7 15l4-4 3 2 5-6" /><path d="M16 7h3v3" /></svg><span class="policy-utility-label">指标监测</span>
    </button>
    <button v-if="!legacy" type="button" class="policy-utility-action" :disabled="inactive" aria-label="任务引导" title="任务引导" @click="$emit('guide')">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 8a3 3 0 0 1 6 0c0 2-3 2.4-3 4.5M12 16.5h.01" /><circle cx="12" cy="12" r="9" /></svg><span class="policy-utility-label">任务引导</span>
    </button>
    <button v-if="!legacy" type="button" class="policy-utility-action" :disabled="inactive" aria-label="案例背景" title="案例背景" @click="$emit('background')">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 4h9l3 3v13H6zM15 4v4h3M9 12h6M9 15h6" /></svg><span class="policy-utility-label">案例背景</span>
    </button>
    <button type="button" class="policy-utility-action" :disabled="inactive || busy" aria-label="刷新状态" title="刷新状态" @click="$emit('refresh')">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 8a8 8 0 0 0-14-1M5 4v3h3M5 16a8 8 0 0 0 14 1M19 20v-3h-3" /></svg><span class="policy-utility-label">刷新状态</span>
    </button>
  </div>
</template>

<script>
export default { name: 'PolicyQuickActions', props: { indicatorActive: Boolean, busy: Boolean, legacy: Boolean, inactive: Boolean } }
</script>
